import React, { Component } from 'react'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import Slider from 'react-slick'
import './index.scss'

import srcLOne from '../../assets/images/banner/banner_l_01.jpg'
import srcLTwo from '../../assets/images/banner/banner_l_02.jpg'
import srcLThree from '../../assets/images/banner/banner_l_03.jpg'
import srcLFour from '../../assets/images/banner/banner_l_04.jpg'
import srcLFive from '../../assets/images/banner/banner_l_05.jpg'
import srcLSix from '../../assets/images/banner/banner_l_06.jpg'
import srcLSeven from '../../assets/images/banner/banner_l_07.jpg'

import srcMOne from '../../assets/images/banner/banner_m_01.jpg'
import srcMTwo from '../../assets/images/banner/banner_m_02.jpg'
import srcMThree from '../../assets/images/banner/banner_m_03.jpg'
import srcMFour from '../../assets/images/banner/banner_m_04.jpg'
import srcMFive from '../../assets/images/banner/banner_m_05.jpg'
import srcMSix from '../../assets/images/banner/banner_m_06.jpg'
import srcMSeven from '../../assets/images/banner/banner_m_07.jpg'

import srcSOne from '../../assets/images/banner/banner_s_01.jpg'
import srcSTwo from '../../assets/images/banner/banner_s_02.jpg'
import srcSThree from '../../assets/images/banner/banner_s_03.jpg'
import srcSFour from '../../assets/images/banner/banner_s_04.jpg'
import srcSFive from '../../assets/images/banner/banner_s_05.jpg'
import srcSSix from '../../assets/images/banner/banner_s_06.jpg'
import srcSSeven from '../../assets/images/banner/banner_s_07.jpg'

class Banner extends Component {
  constructor(props) {
    super(props)
    this.state = {
      items: [
        {
          srcL: srcLOne,
          srcM: srcMOne,
          srcS: srcSOne
        },
        {
          srcL: srcLTwo,
          srcM: srcMTwo,
          srcS: srcSTwo
        },
        {
          srcL: srcLThree,
          srcM: srcMThree,
          srcS: srcSThree
        },
        {
          srcL: srcLFour,
          srcM: srcMFour,
          srcS: srcSFour
        },
        {
          srcL: srcLFive,
          srcM: srcMFive,
          srcS: srcSFive
        },
        {
          srcL: srcLSix,
          srcM: srcMSix,
          srcS: srcSSix
        },
        {
          srcL: srcLSeven,
          srcM: srcMSeven,
          srcS: srcSSeven
        }
      ],
      imageSize: ''
    }
    this.settings = {
      dots: true,
      autoplay: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      lazyLoad: 'progressive'
    }
  }
  componentDidMount() {
    this.setImageSize()
    window.addEventListener('resize', this.setImageSize)
  }
  setImageSize = () => {
    let imageSize = ''
    if (window.innerWidth >= 1200) {
      imageSize = 'L'
    } else if (window.innerWidth >= 768) {
      imageSize = 'M'
    } else {
      imageSize = 'S'
    }
    if (this.state.imageSize !== imageSize) {
      this.setState({ imageSize })
    }
  }
  getSourceImage = (item) => {
    const key = 'src' + this.state.imageSize
    return item[key]
  }
  render() {
    return (
      <div className="ch-banner" id="banner">
        <Slider {...this.settings}>
          {this.state.items.map((item, i) => {
            return (
              <div key={i}>
                <img src={this.getSourceImage(item)} alt="chefhung-banner" />
              </div>
            )
          })}
        </Slider>
      </div>
    )
  }
}

export default Banner
